<template>
  <form
    v-if="showFeedbackForm"
    v-bind:key="faq.id"
    class="cxco-c-feedback"
  >
    <div class="cxco-c-feedback__wrapper">
      <p class="cxco-c-feedback__title" v-if="!faq.feedback.sent" :id="`faq-feedback-text-${faq.id}`">
        {{ faq.feedback.message }}
      </p>
      <ul
        v-if="shouldShowFeedbackButtons"
        class="cxco-o-buttongroup cxco-o-buttongroup--right"
        :aria-describedby="`faq-feedback-text-${faq.id}`"
      >
        <li class="cxco-o-buttongroup__item">
          <button
            @click.prevent="actions.feedbackClick(faq, 1)"
            class="cxco-c-button cxco-c-button--outlined"
          >
            {{ state.feedback.positive }}
          </button>
        </li>
        <li class="cxco-o-buttongroup__item">
          <button
            @click.prevent="negativeFeedbackClick"
            class="cxco-c-button cxco-c-button--outlined"
            :data-state="`${faq.feedback.shouldShowTextarea ? 'selected' : ''}`"
          >
            {{ state.feedback.negative }}
          </button>
        </li>
      </ul>
    </div>
    <div v-if="faq.feedback?.shouldShowTextarea">
      <label for="feedback-text" class="sr-only">Please provide more details about your feedback</label>
      <textarea
        id="feedback-text"
        class="cxco-c-input"
        @input.prevent="(e) => actions.updateFaqFeedbackComment(faq.id, e)"
        :placeholder="state.feedback.placeholder"
        aria-required="true"
        ref="feedbackForm"
      ></textarea>
      <ul
        v-if="shouldShowFeedbackButtons"
        class="cxco-o-buttongroup cxco-o-buttongroup--right"
      >
        <li class="cxco-o-buttongroup__item">
          <button
            @click.prevent="actions.feedbackClick(faq, -1)"
            class="cxco-c-button cxco-c-button--outlined"
          >
            {{ state.feedback.submit }}
          </button>
        </li>
      </ul>
    </div>

    <Notify
      :message="faq.feedback.message"
      :show="faq.feedback.showFeedbackNotify"
      :click="() => actions.toggleFeedbackNotify(faq.id)"
      :type="'success'"
    />
  </form>
</template>
<script>
import { inject } from "vue";
import Notify from "./notify";

export default {
  components: { Notify },
  props: {
    faq: Object,
  },
  setup() {
    const state = inject("state");
    const actions = inject("actions");
    return { state, actions };
  },
  computed: {
    showFeedbackForm() {
      return this.state.feedback.show && 
             this.faq.feedback && 
             Object.keys(this.faq.feedback).length > 0
    },
    shouldShowFeedbackButtons() {
      return !this.faq.feedback.sent
    }
  },
  methods: {
    negativeFeedbackClick() {
      this.actions.feedbackClick(this.faq, -1);
      this.$nextTick(() => {
        if (this.$refs.feedbackForm) {
          this.$refs.feedbackForm.focus();
        }
      });
    }
  }
};
</script>
